/**
  Autogenerated file. Do not edit manually.
  @openapi https://ai-chat-bot.envdevel.com/v3/api-docs
*/

import type {
  ChatbotRequest,
  ChatbotResponse
} from '../../models';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Evaluates the latest user conversation entry together with optional context, conversation history,
 * page skills, and global skills to return either an answer, a follow-up question, or a skill to execute.
 * @summary Resolve the next chatbot message
 */
export const message = (
    chatbotRequest: ChatbotRequest,
 options?: SecondParameter<typeof customInstance<ChatbotResponse>>,) => {
      return customInstance<ChatbotResponse>(
      {url: `/api/v1/ai-chatbot/message`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: chatbotRequest
    },
      options);
    }
  export type MessageResult = NonNullable<Awaited<ReturnType<typeof message>>>
